import React, { useEffect, useState } from "react";
import Pager from "../components/Pager";
import { connect } from 'react-redux';
import axios from "axios";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

const Pantalla3Enc10059 = ({ loggedstate }) => {
    const [page, setPage] = useState(1);
    const [resultados, setResultados] = useState([]);
    const [totales, setTotales] = useState(1);

    const clienteid = loggedstate?.vars?.clienteid;
    const encuesta = loggedstate?.vars?.encuesta;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const formData = new FormData();
                formData.append('cliente', clienteid || '');
                formData.append('encuesta', encuesta || '');
                formData.append('pagina', page);

                const response = await axios.post(
                    process.env.REACT_APP_URL + 'pantalla3Enc10059.php',
                    formData,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );

                const data = response.data;
                setResultados(data.resultados || []);
                setTotales(data.totales || 1);
            } catch (err) {
                console.error('Error fetching registros:', err);
                setResultados([]);
                setTotales(1);
            }
        };

        fetchData();
    }, [clienteid, encuesta, page]);

    const handleChange = (newPage) => {
        setPage(newPage);
    };

    return (
        <div id="pantalla3" className="contenedorgrafica">
            <Table className="Table Table-borderless Table-striped Table-earning">
                <Thead>
                    <Tr id="cabezal">
                        <Th>Fecha</Th>
                        <Th>Tienda</Th>
                        <Th>Ticket</Th>
                        <Th>Calificación</Th>
                        <Th></Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {resultados.map((linea, index) => (
                        <Tr key={index}>
                            <Td>{linea.fecha}</Td>
                            <Td>{linea.sucursal}</Td>
                            <Td>{linea.ticket}</Td>
                            <Td>{linea.calificacion}</Td>
                            <Td><a href={process.env.REACT_APP_URL + "cuestionario.php?id=" + linea.levantamiento + "&encuesta=" + encuesta} target="_blank" rel="noreferrer">Ver</a> | <a href={process.env.REACT_APP_URL + "cuestionario.php?id=" + linea.levantamiento + "&encuesta=" + encuesta + "&pdf=true"} target="_blank" rel="noreferrer">PDF</a></Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>

            <Pager page={page} totales={totales} onPageChange={handleChange} />
        </div>
    );
};

const mapStateToProps = state => ({ loggedstate: state });
export default connect(mapStateToProps)(Pantalla3Enc10059);